import type { PortfolioItem } from "./types";

// export const data = [
//     {
//         "id": "0",
//         "title": "Morse Code Academy",
//         "date": "2020",
//         "category": [
//             "App",
//             "Website"
//         ],
//         "info": "Educational Mobile Application teaches morse code in 6 different languages by games.",
//         "technologies": [
//             "Android Studio",
//             "html | CSS | Bootstrap ",
//             "Js | JQUERY",
//             "php | laravel"
//         ],
//         "images": [
//             "mca/logo.webp",
//             "mca/mca_logo_phone.webp",
//             "mca/p1.webp",
//             "mca/p2.webp",
//             "mca/p3.webp",
//             "mca/p4.webp",
//             "mca/p5.webp",
//             "mca/p6.webp",
//             "mca/p7.webp",
//             "mca/p8.webp",
//             "mca/p9.webp",
//             "mca/p10.webp",
//             "mca/p11.webp",
//             "mca/p12.webp",
//             "mca/p13.webp",
//         ],
//     },
//     {
//         "id": "1",
//         "title": "Armnotes",
//         "date": "2022",
//         "category": [
//             "App",
//             "Website"
//         ],
//         "info": "Social Networking and Music sharing application , reading blogs, checking music notes, adding posts, linking, commenting ",
//         "technologies": [
//             "React Native",
//             "html | CSS | Bootstrap ",
//             "Js | JQUERY", "php | laravel"
//         ],
//         "images": [
//             "armnotes/logo.webp",
//             "armnotes/0.webp",
//             "armnotes/1.webp",
//             "armnotes/2.webp",
//             "armnotes/3.webp",
//             "armnotes/4.webp",
//             "armnotes/5.webp",
//             "armnotes/6.webp",
//         ],
//     },
//     {
//         "id": "2",
//         "title": "Alpha Hangman Desktop Game ",
//         "date": "2021",
//         "category": ["Desktop Application"],
//         "info": " Hangman game with 3 difficulty levels with different animations.",
//         "technologies": [
//             "JAVA",
//             "JAVAFX",
//             "FXML"],
//         "images": [
//             "hangman/logo.webp",
//             "hangman/1.jpeg",
//             "hangman/2.jpeg",
//             "hangman/3.jpeg",
//         ],
//     },
//     {
//         "id": "3",
//         "title": "Covid-19 Web Platform ",
//         "date": "2019",
//         "category": ["Website"],
//         "info": " Covid-19 platform for registering vaccines & adding vaccine symptoms, adding danger zones, adding posts, " +
//             "liking, commenting, asking questions, answering questions, registering for pcr and checking pcr results, reading blogs",
//         "technologies": [
//             "html | CSS | Bootstrap ",
//             "Js | JQUERY",
//             "php | laravel"
//         ],
//         "images": [
//             "covidweb/logo.webp",
//             "covidweb/1.webp",
//             "covidweb/2.webp",
//             "covidweb/3.webp",
//             "covidweb/4.webp",
//         ],
//     },
//     {
//         "id": "4",
//         "title": "Covid-19 Tracking System ",
//         "date": "2021",
//         "category": ["Website", "Application"],
//         "info": " Covid-19 platform for registering in a 24 hour tracking system for 15 days , violations when missed , rewards",
//         "technologies": [" React Native Expo", "html | CSS | Bootstrap ", "Js | JQUERY", "php | laravel"],
//         "images": [
//             "covidapp/logo.webp",
//             "covidapp/0.webp",
//             "covidapp/1.webp",
//             "covidapp/2.webp",
//             "covidapp/3.webp",
//             "covidapp/4.webp",
//             "covidapp/5.webp",
//             "covidapp/6.webp",
//         ],
//     },
//     {
//         "id": "5",
//         "title": "PUNIG BAND",
//         "date": "2019",
//         "category": ["Website"],
//         "info": " Band Website",
//         "technologies": [
//             "html | CSS | Bootstrap ",
//             "Js | JQUERY"],
//         "images": [
//             "punig/ss.webp", "punig/Punig.webp"
//         ],
//     },
//     {
//         "id": "6",
//         "title": "Guitarist Website",
//         "date": "2018",
//         "category": ["Website"],
//         "info": " Guitarist Website",
//         "technologies": [
//             "html | CSS | Bootstrap ",
//             "Js | JQUERY"
//         ],
//         "images": [
//             "guitar/logo.webp",
//             "guitar/1.webp",
//             "guitar/2.webp",
//             "guitar/3.webp",
//             "guitar/4.webp",
//         ],
//     },
// ]

// {
//     "id": "2",
//     "title": "PUNIG BAND",
//     "date": "2019",
//     "category": ["Website"],
//     "key":"punig",
//     "info": " Band Website",
//     "logo":"punig/ss.webp",
//     "technologies": [
//         "HTML, SCSS, Bootstrap ",
//         "JS, JQUERY"],
//     "images": [
//          "punig/Punig.webp"
//     ],
// }
export const data: PortfolioItem[] = [
    {
        "id": "0",
        "title": "Vireon Scaffolding",
        "key": "vireon",
        "date": "2022",
        "category": [
            "Website"
        ],
        "website": "https://seroujkhandjihanian.com/portfolio/vireon/public/",
        "info": "Construction Company",
        "technologies": [
            "HTML, SCSS, Bootstrap ",
            "JS, JQUERY", "php, Laravel"
        ],
        "logo": "vireon/logo.webp",
        "images": [
            "vireon/1.webp",
            "vireon/2.webp",
            "vireon/3.webp",
            "vireon/4.webp",
            "vireon/5.webp",
            "vireon/6.webp",
        ],
    },
    {
        "id": "1",
        "title": "AGF",
        "key": "agf",
        "date": "2022",
        "category": [
            "Website"
        ],
        "website": "https://seroujkhandjihanian.com/portfolio/agf/public/",
        "info": "Freight & Cargo Company",
        "technologies": [
            "HTML, SCSS, Bootstrap ",
            "JS, JQUERY", "php, Laravel"
        ],
        "logo": "agf/logo.webp",
        "images": [
            "agf/1.webp",
            "agf/2.webp",
            "agf/3.webp",
            "agf/4.webp"
        ],
    },
    {
        "id": "2",
        "key": "morse",
        "title": "Morse Code Academy",
        "date": "2020,2025",
        "website": "https://morsecodeacademy.site",
        "category": [
            "App",
            "Website"
        ],
        "info": "Educational Mobile Application teaches morse code in 6 different languages by games.",
        "technologies": [
            "React Native, Firebase",
            "HTML, CSS, Bootstrap ",
            "JS, JQUERY",
            "php, Laravel"
        ],
        "logo": "mca/logo.webp",
        "images": [
            "mca/1.webp",
            "mca/2.webp",
            "mca/4.webp",
            "mca/5.webp",
            "mca/6.webp",
            "mca/7.webp",
            "mca/8.webp",
            "mca/9.webp",
            "mca/10.webp",
            "mca/11.webp",
            "mca/12.webp",
            "mca/13.webp",
        ],
    },
    {
        "id": "3",
        "title": "Darpersol Electrical",
        "key": "darpersol",
        "date": "2023",
        "category": [
            "Website"
        ],
        "website": "https://seroujkhandjihanian.com/portfolio/darpersol/public/",
        "info": "Construction Company",
        "technologies": [
            "HTML, SCSS, Bootstrap ",
            "JS, JQUERY", "php, Laravel"
        ],
        "logo": "darpersol/logo.webp",
        "images": [
            "darpersol/1.webp",
            "darpersol/2.webp",
            "darpersol/3.webp",
            "darpersol/4.webp",
        ],
    },
    {
        "id": "5",
        "title": "House Hunters",
        "key": "house-hunters",
        "date": "2020",
        "category": [
            "Website"
        ],
        "website": "https://seroujkhandjihanian.com/portfolio/househunters/public/",
        "info": "Social Networking and Music sharing application , reading blogs, checking music notes, adding posts, liking, commenting",
        "technologies": [
            "React Native",
            "HTML, SCSS, Bootstrap ",
            "JS, JQUERY", "php, Laravel"
        ],
        "logo": "house-hunters/logo.webp",
        "images": [
            "house-hunters/0.webp",
            "house-hunters/1.webp",
            "house-hunters/2.webp",
        ],
    },
    {
        "id": "4",
        "title": "Armnotes",
        "key": "armnotes",
        "date": "2023",
        "category": [
            "App",
            "Website"
        ],
        "website": "https://armnotes.com/",
        "info": "Social Networking and Music sharing application , reading blogs, checking music notes, adding posts, liking, commenting",
        "technologies": [
            "React Native",
            "HTML, SCSS, Bootstrap ",
            "JS, JQUERY", "php, Laravel"
        ],
        "logo": "armnotes/logo.webp",
        "images": [
            "armnotes/0.webp",
            "armnotes/1.webp",
            "armnotes/2.webp",
            "armnotes/3.webp",
            "armnotes/4.webp",
            "armnotes/5.webp",
            "armnotes/6.webp",
            "armnotes/0.webp",
        ],
    },
]
